import { FC } from 'react';
import ModalAtom, { ModalAtomProps } from 'components/atoms/ModalAtom';
import PrimaryButton from 'components/atoms/Button/PrimaryButton';
import DefaultButton from 'components/atoms/Button/DefaultButton';

export interface DeleteUserConfirmModalLiterals {
  title: string;
  mainButtonText: string;
  secondaryButtonText: string;
  text: string;
}

export interface Props extends ModalAtomProps {
  literals: DeleteUserConfirmModalLiterals;
  onConfirmDeleteUser: () => void;
  loading: boolean;
};

export const DeleteUserConfirmModal: FC<Props> = ({
  literals,
  onCancel,
  onConfirmDeleteUser,
  open,
  loading,
}) => {
  const {
    title,
    mainButtonText,
    secondaryButtonText,
    text,
  } = literals;

  return (
    <ModalAtom
      title={title}
      onCancel={onCancel}
      footer={[
        <DefaultButton
          key={'back'}
          onClick={onCancel}
          title={secondaryButtonText}
        />,
        <PrimaryButton
          key={'submit'}
          loading={loading}
          title={mainButtonText}
          onClick={onConfirmDeleteUser}
        />,
      ]}
      open={open}
      destroyOnClose
    >
      {text}
    </ModalAtom>
  );
};
